import pdfMake from 'addthaifont-pdfmake';
import 'addthaifont-pdfmake/build/vfs_fonts';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import dayjs from 'dayjs';
import _ from 'lodash';
import THBText from 'thai-baht-text';

pdfMake.fonts = {
  Sarabun: {
    normal: 'Sarabun-Light.ttf',
    bold: 'Sarabun-Regular.ttf',
    italics: 'Sarabun-LightItalic.ttf',
    bolditalics: 'Sarabun-Italic.ttf',
  },
};
dayjs.locale('th');
dayjs.extend(buddhistEra);
dayjs.extend(LocalizedFormat);

const billbuyGoldReport = async (data) => {
  
  const cashCheck = data?.payment?.cash?.status === true;
  const transferCheck = data?.payment?.transfer?.status === true;
  const creditCheck = data?.payment?.credit?.status === true;
  
  const bankDetails = data?.payment?.transfer?.bank?.name + ' ' + data?.payment?.transfer?.bank?.accountNumber;
  
  const content = [];
  
  // วนลูปสร้างแต่ละหน้าสำหรับแต่ละรายการ
  data?.order?.forEach((order, index) => {
    
    const tableHeader = [
      [
        { text: 'ชื่อผู้ซื้อ', alignment: 'center', border: [true, true, true, true] },
        { text: data?.customer?.name, alignment: 'left', border: [true, true, true, true], colSpan: 3 },{},{},
        { text: 'วันที่', alignment: 'center', border: [true, true, true, true] },
        { text: dayjs(data?.date).format('DD MMMM BBBB เวลา HH:MM'), alignment: 'left', border: [true, true, true, true], colSpan: 3 },{},{},
      ],
      [
        { text: 'ที่อยู่', alignment: 'center', border: [true, true, true, false] },
        { text: data?.customer?.address, alignment: 'left', border: [true, true, true, false], colSpan: 3 },{},{},
        { text: 'ราคาทองแท่งขายออก', alignment: 'center', border: [true, true, true, true], colSpan: 2 },{},
        { text: (order?.price_gold || 0).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}), alignment: 'center', border: [true, true, true, true] },
        { text: 'บาท', alignment: 'center', border: [true, true, true, true] },
      ],
      [
        { text: '', border: [true, false, true, false]},
        { text: '', alignment: 'left', border: [true, false, true, false], colSpan: 3 },{},{},
        { text: 'ราคาทองรูปพรรณซื้อคืนต่อบาท', alignment: 'center', border: [true, true, true, true], colSpan: 2 },{},
        { text: (order?.pricebackperbath || 0).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}), alignment: 'center', border: [true, true, true, true]},
        { text: 'บาท', alignment: 'center', border: [true, true, true, true] },
      ],
      [
        { text: '', border: [true, false, true, false]},
        { text: data?.customer?.tel, alignment: 'left', border: [true, false, true, false], colSpan: 3 },{},{},
        { text: 'ราคาทองรูปพรรณซื้อคืนต่อกรัม', alignment: 'center', border: [true, true, true, true], colSpan: 2 },{},
        { text: (order?.pricebackpergram || 0).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}), 
            alignment: 'center', border: [true, true, true, true] },
        { text: 'บาท', alignment: 'center', border: [true, true, true, true] },
      ],
      [
        { text: 'เลขประจำตัวผู้เสียภาษี', border: [true, true, true, true], colSpan: 2},{},
        { text: data?.customer?.tax?.taxnumber, alignment: 'center', border: [true, true, true, true], colSpan: 2 },{},
        { text: 'สำนักงานใหญ่', alignment: 'right', border: [true, true, true, true]},
        { text: 'X', alignment: 'left', border: [true, true, true, true]},
        { text: 'สาขาที่', alignment: 'right', border: [true, true, true, true]},
        { text: ' ', alignment: 'center', border: [true, true, true, true] },
      ],
      [
        { text: 'รายการสินค้า', alignment: 'center', border: [true, true, true, true], colSpan: 3 },{},{},
        { text: 'น้ำหนัก(กรัม)', alignment: 'center', border: [true, true, true, true] },
        { text: 'จำนวน', alignment: 'center', border: [true, true, true, true] },
        { text: 'ราคาต่อหน่วย', alignment: 'center', border: [true, true, true, true] },
        { text: 'รวมจำนวนเงิน(บาท)', alignment: 'center', border: [true, true, true, true], colSpan: 2 },{},
      ],
    ];
    
    // สร้างแถวสำหรับรายการนี้
    const itemRow = [
      { text: order?.material?.name || '', alignment: 'center', border: [true, false, false, false], colSpan: 2 },{},
      { text: order?.material?.material_type?.name || '', alignment: 'right', border: [false, false, false, false] },
      { text: (order?.weight || 0).toFixed(2), alignment: 'right', border: [true, false, true, false] },
      { text: (order?.quantity || 0).toString(), alignment: 'right', border: [true, false, true, false] },
      { text: (order?.cost || 0).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}), alignment: 'right', border: [true, false, true, false] },
      { text: (order?.cost || 0).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}), alignment: 'right', border: [true, false, true, false], colSpan: 2 },{},
    ];
    
    let fullTableBody = [...tableHeader, itemRow];
    
    // สร้างแถวว่างเพื่อเติมพื้นที่
    const emptyRows = [];
    for (let i = 0; i < 8; i++) {
      emptyRows.push([
        { text: '', border: [true, false, true, false], colSpan: 3 },{},{},
        { text: '', border: [true, false, true, false] },
        { text: '', border: [true, false, true, false] },
        { text: '', border: [true, false, true, false] },
        { text: '', border: [true, false, true, false], colSpan: 2 },{},
      ]);
    }
    
    fullTableBody.push(...emptyRows);
    
    // แถวปิดตาราง
    fullTableBody.push([
      { text: '\n', border: [true, false, true, true], colSpan: 3 },{},{},
      { text: '\n', border: [true, false, true, true] },
      { text: '\n', border: [true, false, true, true] },
      { text: '\n', border: [true, false, true, true] },
      { text: '\n', border: [true, false, true, true], colSpan: 2 },{},
    ]);
    
    // สร้าง summary rows สำหรับรายการนี้
    const summaryRows = [
      [
        { text: '', border: [false, false, false, false] },
        { text: 'รวมน้ำหนักสุทธิ(กรัม)', alignment: 'center', border: [true, true, true, true], colSpan: 2 },{},
        { text: (order?.weight || 0).toFixed(2), alignment: 'right', border: [true, true, true, true] },
        { text: 'รวมจำนวนเงินสุทธิ(บาท)', alignment: 'center', border: [true, true, true, true], colSpan: 2 },{},
        { text: (order?.cost || 0).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}), alignment: 'right', border: [true, true, true, true], colSpan: 2 },{},
      ],
      [
        { text: cashCheck ? 'x' : ' ', alignment: 'center', border: [true, true, true, true] },
        { text: 'เงินสด', alignment: 'center', border: [true, true, true, true] },
        { text: '', border: [false, false, false, false], colSpan: 2 },{},
        { text: 'ราคาสินค้าก่อนภาษีมูลค่าเพิ่ม', alignment: 'center', border: [true, true, true, true], colSpan: 2 },{},
        { text: (order?.totalbeforeVat || 0).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}), alignment: 'right', border: [true, true, true, true], colSpan: 2 },{},
      ],
      [
        { text: creditCheck ? 'x' : ' ', alignment: 'center', border: [true, true, true, true] },
        { text: 'บัตรเครดิต', alignment: 'center', border: [true, true, true, true] },
        { text: '', border: [false, false, false, false], colSpan: 2 },{},
        { text: 'หักราคาทองรูปพรรณซื้อคืน', alignment: 'center', border: [true, true, true, true], colSpan: 2 },{},
        { text: (order?.baseTotalVat || 0).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}), alignment: 'right', border: [true, true, true, true], colSpan: 2 },{},
      ],
      [
        { text: transferCheck ? 'x' : ' ', alignment: 'center', border: [true, true, true, true] },
        { text: 'ธนาคาร', alignment: 'center', border: [true, true, true, true] },
        { text: bankDetails || '', alignment: 'left', border: [true, true, true, true], colSpan: 2 },{},
        { text: 'ส่วนต่างฐานภาษี', alignment: 'center', border: [true, true, true, true], colSpan: 2 },{},
        { text: (order?.baseVat || 0).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}), alignment: 'right', border: [true, true, true, true], colSpan: 2 },{},
      ],
      [
        { text: '', border: [false, false, false, false], colSpan: 4 },{},{},{},
        { text: 'ภาษีมูลค่าเพิ่ม', alignment: 'center', border: [true, true, true, true], colSpan: 2 },{},
        { text: (order?.vat || 0).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}), alignment: 'right', border: [true, true, true, true], colSpan: 2 },{},
      ],
      [
        { text: '', border: [false, false, false, false] },
        { text: 'ตัวอักษร', alignment: 'center', border: [true, true, true, true] },
        { text: THBText((order?.cost || 0).toFixed(2)), alignment: 'left', border: [true, true, true, true], colSpan: 6 },{},{},{},{},{},
      ],
      [
        { text: '\nผู้รับสินค้า...................................................', alignment: 'left', border: [false, false, false, false], colSpan: 3 },{},{},
        { text: '', border: [false, false, false, false] },
        { text: '\nผู้รับเงิน....................................................', alignment: 'left', border: [false, false, false, false], colSpan: 4 },{},{},{},
      ],
    ];
    
    fullTableBody.push(...summaryRows);
    
    const pageTable = {
      margin: [0, 12],
      table: {
        headerRows: 0,
        widths: ['10%', '*', '*', 'auto', 'auto', 'auto', 'auto', 'auto'],
        body: fullTableBody
      }
    };

    content.push(pageTable);
    
    // เพิ่ม page break ถ้าไม่ใช่หน้าสุดท้าย
    if (index < data?.order?.length - 1) {
      content.push({ text: '', pageBreak: 'after' });
    }
  });

  const documentRef = {
    pageSize: 'A5',
    pageOrientation: 'landscape',
    pageMargins: [40, 80, 40, 20],
    defaultStyle: {
      font: 'Sarabun',
      fontSize: '9',
    },
    info: {
      title: 'Report',
    },
    header: [
      {
        text: [
          '\n\nห้างหุ้นส่วนจำกัด ห้องทองอัญญรัตน์ สำนักงานใหญ่\n',
          '5 ถรรมนูญวิถี อำเภอหาดใหญ่ จังหวัดสงขลา 90110 โทร 074-244246\n',
          `เลขประจำตัวผู้เสียภาษี 090 3559 003 191                                                เลขที่    ${dayjs(data?.date).format('DD-MM-BBBB')+' -AVT02'}\n`,
          'ใบเสร็จรับเงิน/ใบกำกับภาษี',
        ],
        style: {
          style: 'header',
          alignment: 'center',
          bold: true
        },
      },
    ],
    content: content,
    styles: {
      headerPage: {
        fontSize: 14,
        bold: true,
        alignment: 'center',
      },
      header: {
        fontSize: 11,
        bold: true,
        alignment: 'center',
      },
      header2: {
        bold: true,
      },
    },
    footer: function(currentPage, pageCount) {
      return {
        text: currentPage + ' / ' + pageCount,
        alignment: 'center',
        fontSize: 8,
        margin: [0, 0, 0, 10]
      };
    }
  };

  pdfMake.createPdf(documentRef).open();
};

export default billbuyGoldReport;